export const ethics_policy = `
<h1>인터넷신문윤리강령</h1>

<h2 style="margin-top: 15px">[전문]</h2>
<p style="margin-top: 15px">
인터넷신문은 자유롭고 책임 있는 언론을 실현해 주어진 시대적 사명을 다할 것을 다짐한다. 건전한 여론 형성과 민주주의 발전, 문화창달에 기여하기 위하여 우리는 스스로 윤리기준을 세워 인터넷신문윤리강령을 제정하고 이를 실천할 것을 결의한다.
</p>

<h2 style="margin-top: 15px">제1조 언론의 자유</h2>
<p>인터넷신문의 모든 구성원은 국민의 알권리가 실현되도록 대내외적인 모든 침해와 압력, 제한으로부터 언론의 자유와 독립을 수호한다.</p>

<h2 style="margin-top: 15px">제2조 언론의 책임</h2>
<p>인터넷신문은 사회의 공적기구로서 보도의 사실성, 정확성, 균형성을 추구하고 선정보도를 지양한다. 기사 작성 시 사실과 의견을 구분하고 보도 대상자의 반론권을 보장한다.</p>

<h2 style="margin-top: 15px">제3조 인격권의 보호</h2>
<p>인터넷신문은 공공의 이익에 관한 것으로 정당한 사유가 있지 않는 한 개인의 명예, 사생활, 개인정보 및 그 밖의 인격적 가치를 침해해서는 안 된다.</p>

<h2 style="margin-top: 15px">제4조 약자 보호와 차별금지</h2>
<p>인터넷신문은 인종, 민족, 국적, 지역, 신념, 나이, 성별, 직업, 학력, 계층, 지위 등에 대한 편견과 차별, 혐오를 배제한다. 또한 사회적 약자와 소수자의 권리 보호에 앞장선다.</p>

<h2 style="margin-top: 15px">제5조 저작권 보호</h2>
<p>인터넷신문은 공표된 저작물을 보도에 활용하는 경우 반드시 출처를 표시하고 다른 언론사의 보도와 논평을 표절하지 않는다.</p>

<h2 style="margin-top: 15px">제6조 이해 상충</h2>
<p>인터넷신문의 모든 구성원은 취재·보도 과정에서 알게 된 정보를 이용해 부당한 이익을 취하지 않으며 금품이나 향응을 받아서는 안 된다. 회사는 기자에게 광고, 협찬, 판매 등을 요구해서는 안 되며 기자는 이에 응해서는 안 된다.</p>

<h2 style="margin-top: 15px">제7조 부당 게재 또는 전송 금지</h2>
<p>인터넷신문은 동일하거나 유사한 기사를 반복 게재 또는 전송하지 않으며, 실시간 검색어 등의 오남용이나 과거 기사의 부당한 활용을 하지 않는다.</p>

<h2 style="margin-top: 15px">제8조 기사와 광고의 분리</h2>
<p>인터넷신문은 이용자가 광고를 기사로 오인하지 않도록 기사와 광고를 명확하게 구분해야 한다.</p>

<h2 style="margin-top: 15px">제9조 광고의 신뢰성 확보</h2>
<p>인터넷신문은 이용자에게 유용하고 신뢰를 주는 광고 정보를 전달하기 위해 노력하고, 선정적이거나 혐오스런 광고를 지양한다. 또한 이용자를 기망하지 않고 기사 가독성을 저해하지 않는 방법으로 광고를 배치한다.</p>

<h2 style="margin-top: 15px">제10조 이용자 참여</h2>
<p>인터넷신문은 이용자의 건전한 참여 기회를 제공하고 기사의 정당한 이용을 보장한다. 또한 이용자의 게시글 등으로 타인의 권리가 침해되지 않도록 노력한다.</p>

<p style="margin-top: 30px">
<strong>(주)퍼스널뉴스서비스</strong><br>
13486 경기도 성남시 분당구 판교로255번길 35, A동 101호(삼평동 판교실리콘파크)<br>
대표전화 : 031-8039-7035&nbsp;&nbsp;&nbsp;&nbsp;팩스 : 031-8039-7036
</p>`
